import React, { Component } from 'react';
import * as $ from 'jquery';
import Vcontract from './Vcontract.js';
import AcceptedVcontract from './AcceptedVcontract.js';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import axios from 'axios';
import spinner from '../../images/loading-spinner.gif';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

let cancelToken;

class VcontractContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    $(window).off("resize", this.resize);
    
    if( this.props.lang != this.props.match.params.lang){
      this.props.handleLanguageChange();
    }

  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
    this.reload();
  }

  componentWillReceiveProps() {
    $('#content')[0].scrollIntoView();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  getVcontract = (params) => {
    this.props.post(
      "/getVcontract",
      params,
      (response) => this.didGetVcontract(response),
      (error) => {
        this.setState({ toDashboard: true });
        this.props.handleErrorResponse(error);
      },
      cancelToken
    );
  }

  didGetVcontract = (response) => {
    this.setState({ confirmed: true });
    this.setState({ contract: response });
    if(response.contrato_virtual_aceptado == 'Si'){
      this.setState({ toAcceptedContract: true });
    }
  }

  handleVcontractSubmit = (event) => {
    event.preventDefault();

    this.acceptVcontract({
      token_id: this.props.getTokenId(),
      token_vcontract: this.props.match.params.token_vcontract
    });
  }

  acceptVcontract = (params) => {
    this.props.post(
      "/acceptVcontract",
      params,
      (response) => this.didAcceptVcontract(response),
      (error) => {
        this.setState({ toDashboard: true });
        this.props.handleErrorResponse(error);
      },
      cancelToken
    );

    this.didAcceptVcontract();

  }

  didAcceptVcontract = () => {
    this.setState({ toAcceptedContract: true });
  }

  getInitState = () => {
    return {
      confirmed: false,
      toDashboard: false,
      toAcceptedContract: false,
      contract: {}
    };
  }

  reload = () => {
    this.getVcontract({
      token_id: this.props.getTokenId(),
      token_vcontract: this.props.match.params.token_vcontract
    });
  }

  resize = () => {
    $('#content').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  renderVcontract = () => {
    return(
      <Vcontract
      contract={this.state.contract}
      handleVcontractSubmit={this.handleVcontractSubmit} />
    );
  }

  renderAcceptedVcontract = () => {
    return(
      <AcceptedVcontract lang={this.props.lang} />
    );
  }

  renderFooter = () => {
    return(
      <Footer />
    );
  }

  renderNavbar = () => {
    return(
      <Navbar
        handleLanguageChange={this.props.handleLanguageChange}
        lang={this.props.lang} />
    );
  }

  render() {
    const { t } = this.props;

    if (this.state.toDashboard) {
      return <Redirect to="/events" />;
    }

    return(
      <div>
        {this.renderNavbar()}
        <div className="container-fluid" id="content">
          {!this.state.confirmed &&
            <div className="container-padding text-center">
              <img
                width="100px"
                height="100px"
                alt={t('guest.img_spinner')}
                src={spinner} />
            </div>
          }
          {this.state.confirmed && !this.state.toAcceptedContract && this.renderVcontract()}
          {this.state.toAcceptedContract && this.renderAcceptedVcontract()}
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(VcontractContainer);



// WEBPACK FOOTER //
// ./src/guest/vcontract/VcontractContainer.js